import { PropsWithChildren } from 'react';

import { shadowDividerProps } from 'utils/theme';

import { Stack } from '@cast/design-system';
import type { StackProps } from '@cast/design-system';

export const ChartSectionBox = ({
  children,
  ...props
}: PropsWithChildren<StackProps>) => {
  return (
    <Stack
      display="grid"
      gridTemplateRows="70px 150px"
      sx={{
        '& > :not(:first-of-type):before': {
          ...shadowDividerProps('horizontal'),
          content: '""',
          left: 0,
        },
      }}
      data-testid="network-chart"
      {...props}
    >
      {children}
    </Stack>
  );
};
